export const PREMIUM_PLAN_NAMES = ['Growing', 'Pro', 'Crescendo', 'Profissional'];

export const PREMIUM_PLAN_DISPLAY_NAMES = ['Crescendo', 'Profissional'];

export const PREMIUM_FEATURE_TOOLTIP =
    'Recurso disponível nos planos Crescendo e Profissional.';

export function hasPremiumAccess(planName) {
    const normalized = String(planName || '').trim();
    if (!normalized) {
        return false;
    }
    return PREMIUM_PLAN_NAMES.includes(normalized);
}

export function readStoredPlanName() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return user.plan_name || 'Free';
    } catch {
        return 'Free';
    }
}
